module.exports = __webpack_public_path__ + "static/img/invest-envir1.71becc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-envir1.jpg
// module id = MXwz
// module chunks = 0